import * as yup from 'yup';

export const hoursFromToSchema = () => yup.object({
    from: yup.string().required().matches(/^\\d{2}:\\d{2}$/),
    to: yup.string().required().matches(/^\\d{2}:\\d{2}$/),
});
